import { type FC, type ReactNode, useMemo, useRef } from 'react';
import type { SimInventorySegmentName } from 'types/common';
import createSimInventoryStore, { type SimInventoryStore } from './createSimInventoryStore';
import SimInventoryStoreContext from './SimInventoryStoreContext';

interface SimInventoryStoreProviderProps {
  children?: ReactNode;
  simInventorySegmentName: SimInventorySegmentName;
  organizationId?: OrgId;
}

const SimInventoryStoreProvider: FC<SimInventoryStoreProviderProps> = ({
  children,
  simInventorySegmentName,
  organizationId,
}) => {
  const storeRef = useRef<Map<string, SimInventoryStore>>(new Map());

  const key =
    simInventorySegmentName === 'all'
      ? simInventorySegmentName
      : `${organizationId}-${simInventorySegmentName}`;

  const store = useMemo(() => {
    if (!storeRef.current.has(key)) {
      storeRef.current.set(key, createSimInventoryStore(key));
    }

    return storeRef.current.get(key);
  }, [key]);

  return (
    <SimInventoryStoreContext.Provider value={store}>{children}</SimInventoryStoreContext.Provider>
  );
};

export default SimInventoryStoreProvider;
